declare global {
  interface Window {
    reactFunctionHandler?: (data: {}) => Promise<{}>;
  }
}
import * as React from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./Redux/store";
import { fetchAllMatters } from "./Redux/matterSlice";
import { fetchAllTags } from "./Redux/tagSlice";
import {IconButton, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { fetchAllServiceType } from "./Redux/serviceTypeSlice";
import { fetchAllActivityCode } from "./Redux/activityCodeSlice";
import { fetchAllTaskCode } from "./Redux/taskCodeSlice";
import EmailLoggingForm from "./ui/EmailLog";
import LogClarraDocsForm from "./ui/LogClarraDocsForm";
import LogTimeslipForm from "./ui/LogTimeslipForm";
import { SaveCommuncation } from "./Redux/communicationSlice";
import { useAlert } from "./MessageAlert/AlertContext";
import { SaveTimeSlip } from "./Redux/timeSlipSlice";
// import OfficeRuntime from "office-runtime";
import { SaveClarraDocs } from "./Redux/clarraDocsSlice";
import { Box } from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Loader from "./MessageAlert/Loader";
import CommunicationStatus from "./MessageAlert/SuccessAlert";
import Status from "./ui/Status";
import { useAuth0 } from "@auth0/auth0-react";
import { fetchAllContacts } from "./Redux/contactSlice";
import { fetchAllUsers } from "./Redux/userSlice";
import { GetTimeSlipSetting } from "./Redux/timeSlipSettingsSlice";
import Permission from "./ui/Permission";
import axios from "axios";
import { API_BASE_URL, GetPermission, DeleteKey, SetKey } from "../config/config"
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { debug, runtime } from "webpack";
import CheckIcon from "@mui/icons-material/Check";
import Checkbox from "@mui/material/Checkbox";
import {extractTenantIdFromToken, getProfileByEmail, getTokenByLocalStorage, getTokenByProfileEmail, removeUserByProfileEmail, getStorageItem, SetStorageItem } from "../helpers/helpers";
import { setAccessTokenDirect, clearSession as clearTokenManagerSession, getAccessToken as getManagedAccessToken } from "../services/tokenManager";
import { fetchAllLabels } from "./Redux/labelsSlice";
import { BACKEND_ERROR_MAP, LOCALSTORAGE_KEYS} from '../utils/Constants';


interface SuccessPageBodyProps {
  // handleLoginChange: (data: boolean, profileEmail: string) => void;
  handleSingOUt: (data: boolean) => void;
  // other props...
}



function setCustomPropertiesAfterLog({ communicationId, timeSlipId, clarraDocsId, tenantId }) {
    Office.context.mailbox.item.loadCustomPropertiesAsync(res => {
        if (res.status === Office.AsyncResultStatus.Succeeded) {
            const props = res.value;

            // Only set if not already present
            const commKey = `communicationId${tenantId}`;
            const tsKey = `timeSlipId${tenantId}`;
            const cdKey = `clarraDocsId${tenantId}`;

            if (communicationId && !props.get(commKey)) {
                props.set(commKey, communicationId.toString());
                console.log(`[setCustomPropertiesAfterLog] Set ${commKey}:`, communicationId);
            } else if (props.get(commKey)) {
                console.log(`[setCustomPropertiesAfterLog] ${commKey} already exists, not overwriting.`);
            }

            if (timeSlipId && !props.get(tsKey)) {
                props.set(tsKey, timeSlipId.toString());
                console.log(`[setCustomPropertiesAfterLog] Set ${tsKey}:`, timeSlipId);
            } else if (props.get(tsKey)) {
                console.log(`[setCustomPropertiesAfterLog] ${tsKey} already exists, not overwriting.`);
            }

            if (clarraDocsId && !props.get(cdKey)) {
                props.set(cdKey, clarraDocsId.toString());
                console.log(`[setCustomPropertiesAfterLog] Set ${cdKey}:`, clarraDocsId);
            } else if (props.get(cdKey)) {
                console.log(`[setCustomPropertiesAfterLog] ${cdKey} already exists, not overwriting.`);
            }

            props.saveAsync(() => {
                console.log("[setCustomPropertiesAfterLog] Custom properties saved.");
            });
        } else {
            console.error("[setCustomPropertiesAfterLog] Failed to load custom properties:", res.error);
        }
    });
}

const BaseComponent: React.FC<SuccessPageBodyProps> = ({ handleSingOUt }) => {
  const [composeProgress, setComposeProgress] = useState(0);
  const [composeLoader,setComposeLoader]=useState(false);
  const [isOnlyTimeSlip, setOnlyTimeSlip] = useState(false);
  const [isCommunicationEnabled, setCommunicationEnabled] = useState(false);
  const [NoPermission, setPermission] = useState(false);
  const [isOnlyDocs, setOnlyDocs] = useState(false);
  const [isCommunicationSave, setCommunicationSave] = useState(true);
  const [mode, setMode] = useState("Email");
  const [showSuccess, setShowSuccess] = useState(false);
  const [ShowMessageWindow, setShow] = useState(false);
  const [ShowMessage, setShowMessage] = useState("Successfully logged");
  const [ShowError, setShowError] = useState(false);
  const [checkCMode, setCheckCMode] = useState(false);
  const [checkTMode, setCheckTMode] = useState(false);
  const [checkDMode, setCheckDMode] = useState(false);
  const [CurrentMode, SetCurrentMode] = useState(0);
  const [EmailItem, SetEmailItem] = useState({});
  const [show, SetShowSuccessMessage] = useState(false);
  const [selectedFrom, setSelectedFrom] = useState({});
  const [selectedTo, setSelectedTo] = useState([]);
  const [selectedCc, setSelectedCc] = React.useState([]);
  const [Signal, setSignal] = useState(0);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  
const [permissionErrorMsg, setPermissionErrorMsg] = useState<number | null>(null);
 const [isLoader, setIsLoader] = useState(false);
// const [userEmail, setUserEmail] = useState("");

  const SelectedTo = getStorageItem(LOCALSTORAGE_KEYS.SelectedTO);
  const hasRunRef = React.useRef(false);
  const uploadProgress = useSelector((state: RootState) => state.communication.uploadProgress);
  const { uiDictionary, labelloading, isLoaded } = useSelector((state: RootState) => state.labels);
  const tsettings = useSelector((state: RootState) => state.timeSlipSettings.settings);

  const matters = useSelector((state: RootState) => state.matters.matters);
  const tags = useSelector((state: RootState) => state.tags.tags);
  const [files, SetFiles] = useState([
    {
      blobfile: null,
      filename: "",
    },
  ]);
  const [emlfile, Setemlfile] = useState(
    {
      blobfile: null,
      filename: "",
    },
  );
  const [TimeSlipSetting, SetTimeSlipSettings] = useState(
    {
      id: 0,
      disableTimeTracking: false,
      tenantId: 0,
      createdDate: '',
      modifiedDate: '',
      createdById: '',
      modifiedById: '',
      iconName: '',
      billingMinutes: 6,
      zeroDurationType: 0
    });

  const defaultDate = (date) => {
    const Emaildate = getStorageItem(LOCALSTORAGE_KEYS.ItemDate);
    if (Emaildate != null) {
      const date1 = new Date(Emaildate);
      const year = date1.getFullYear();
      const month = String(date1.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const day = String(date1.getDate()).padStart(2, "0");
      return `${month}/${day}/${year}`;
    }
    else {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${month}/${day}/${year}`;
    }
  }

  const formatDate = (date) => {

    const Emaildate = getStorageItem(LOCALSTORAGE_KEYS.ItemDate);
    if (Emaildate != null) {
      const date1 = new Date(Emaildate);
      const year = date1.getFullYear();
      const month = String(date1.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const day = String(date1.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
    else {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
  };
  const [formData, setFormData] = useState({
    isValid: false,
    profileEmail: null,
    billable: true,
    date: formatDate(new Date()),
    duration: "",
    timekeeper: "",
    matter: "",
    matterid:0,
    tag: [],
    activityCode: "",
    taskCode: "",
    subject: "",
    description: "",
    note: "",
    data: "",
    status: "",
    // serviceType: { label: 'E-Mail', value: '958' },
    serviceType: null,
    attachments: files,
    emlattachment: emlfile,
    sendToDocketing: false,
    docketingComplete: false,
    docketingNotes: "",
    Data: "",
    createClarraDocs: false,
    createCommunication: true,
    createTimeslip: false,
    mailItem: {},
    mailbody: "",
    matterdoc: "",
    matteriddoc : 0,
    matterdoc_manually_set: false,
    tagdoc: [],
    datedoc: formatDate(new Date()),
    subjectdoc: "",
    descriptiondoc: "",
    attachmentsdoc: files,
    emlFileName: "",
    datets: formatDate(new Date()),
    matterts: "",
    matteridts : 0,
    matterts_manually_set: false,
    notedoc: "",
    isClarraDocsReadOnly: false,
    isCEmailLogged: false,
    isTimeSlipLogged: false,
    isClarraDocsLogged: false,
    IsComposedMode: true,
    IsComposedTextShown: false,
    CommunicationId: 0,
    TimeSlipId: 0,
    ClarraDocsId: 0,
    AllLogged: false,
    PanelOpenState : "",
    ZapierDownloadURL:[]
  });

  const [errors, setErrors] = useState({
    combinedMessage: "",
    combinedMessagedoc: "",
    combinedMessagets: "",
    From: "",
    To: "",
    billable: true,
    date: "",
    duration: "",
    timekeeper: "",
    matter: "",
    tag: "",
    activityCode: "",
    taskCode: "",
    description: "",
    note: "",
    status: "",
    serviceType: "",
    contact: "",
    matterdoc: "",
    tagdoc: "",
    datedoc: "",
    subjectdoc: "",
    descriptiondoc: "",
    attachmentsdoc: "",
    emlattachment: "",
    emlFileName: "",
    datets: "",
    matterts: "",
    notedoc: "",
    isCEmailLogged: false,
    IsComposedMode: true,
    IsComposedTextShown: false
  });
  const setLocalStorageItem = (key, value) => {
    if (typeof value === "object") {
       SetStorageItem(key, JSON.stringify(value));
    } else {
      SetStorageItem(key, value);
    }
  };

  const getLocalStorageItem = (key) => {
    const value = sessionStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  };



useEffect(() => {
  Office.onReady((info) => {
    const isClassicOutlook = info.platform === Office.PlatformType.PC;
    const isMacOutlook = info.platform === Office.PlatformType.Mac;
    let diagnostics = Office.context.mailbox.diagnostics;
    let hostName = diagnostics.hostName; 
    let host = hostName === "Outlook" ? "1" : "0";

    SetStorageItem(
      LOCALSTORAGE_KEYS.isClassicOutlook,
      isClassicOutlook ? "1" : "0"
    );
    SetStorageItem(
      LOCALSTORAGE_KEYS.isMacOutlook,
      isMacOutlook ? "1" : "0"
    );
    SetStorageItem(LOCALSTORAGE_KEYS.hostName, host);
  });

  setIsDataLoaded(true);
  SetStorageItem(LOCALSTORAGE_KEYS.mode, "1");
  const handleStorageChange = (event: StorageEvent) => {
    if (event.key === "onSendChallenge" && event.newValue) {
      const item = Office.context.mailbox.item;
      if (!item) return;
      const processItemId = (currentPaneItemId: string) => {
        console.log("Current Pane Item ID:", currentPaneItemId);
        const sendingItemId =
          getStorageItem(LOCALSTORAGE_KEYS.currentSendingItem) || "unsaved";
        console.log("Sending Item ID:", sendingItemId);
        if (currentPaneItemId === sendingItemId) {
          setSignal((prev) => prev + 1);
          SetStorageItem(
            LOCALSTORAGE_KEYS.onSendResponse,
            event.newValue!
          );
        }
      };

      if (typeof (item as any).saveAsync === "function") {
        item.saveAsync((result: Office.AsyncResult<string>) => {
          if (
            result.status === Office.AsyncResultStatus.Succeeded
          ) {
            const currentPaneItemId = result.value;
            console.log("Saved Item ID (Compose):", currentPaneItemId);
            processItemId(currentPaneItemId);
          } else {
            console.log("Could not get itemId (compose mode)");
          }
        });

      }
      else if (item.itemId) {
        const currentPaneItemId = item.itemId;
        console.log("Read Mode Item ID:", currentPaneItemId);
        processItemId(currentPaneItemId);
      }
      else {
        console.log("ItemId not available.");
      }
    }
  };
  window.addEventListener("storage", handleStorageChange);
  console.log("Task Pane responder is now listening for challenges.");
  return () => {
    window.removeEventListener("storage", handleStorageChange);
    console.log("Task Pane responder has stopped listening.");
  };
}, []);




useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
        if (e.key === "composeUploadProgress") {
            const val = parseInt(e.newValue || "0");
            setComposeProgress(val);
        }
        if(e.key==="composeloader"){
          const val = parseInt(e.newValue || "1")===0?true:false;
          setComposeLoader(val);
        }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
}, []);


 useEffect(() => {
     if (!isDataLoaded) {
      return;
    }
    if (!formData?.profileEmail || formData.profileEmail.trim() === "") {
      return;
    }
  
    setLocalStorageItem(LOCALSTORAGE_KEYS.formData, formData);
    validateForm();
  }, [formData, isDataLoaded,Signal]);

  
  const dispatch = useDispatch<AppDispatch>();
  const LoginError = useSelector((state: RootState) => state.serviceType.error);
  const communication = useSelector(
    (state: RootState) => state.communication.communication
  );
  const ErrorOnSaveCommuncation = useSelector(
    (state: RootState) => state.communication.error
  );
  const loading = useSelector(
    (state: RootState) => state.communication.loading
  );
  const timeSlip = useSelector((state: RootState) => state.timeSlip.timeslip);
  const timeSlipLoading = useSelector(
    (state: RootState) => state.timeSlip.loading
  );
  const ErrorOnSavetimeSlip = useSelector(
    (state: RootState) => state.timeSlip.error
  );
  const ErrorStatus = useSelector(
    (state: RootState) => state.logStatus.error
  );
  
  const clarraDocs = useSelector(
    (state: RootState) => state.clarraDocs.clarraDocs
  );
  const clarraDocsLoading = useSelector(
    (state: RootState) => state.clarraDocs.loading
  );
  const ErrorOnSaveclarraDocs = useSelector(
    (state: RootState) => state.clarraDocs.error
  );

  const { getAccessTokenSilently, getIdTokenClaims, logout, } = useAuth0();
  const [AccessToken, SetAccessToken] = useState(null);
  const [addCommunication, SetAddCommunication] = useState(true);
  const [addTimeSlip, SetAddTimeslip] = useState(false);
  const [addClarraDocs, SetAddClarraDocs] = useState(false);
  const [isValidToken, SetisValidToken] = useState(false);
  const [isEmailLogged, SetIsEmailLogged] = useState(false);
  const [cheaderColor, SetCHeaderColor] = useState("#E7F6F1");
  const [theaderColor, SetTHeaderColor] = useState("#E7F6F1");
  const [dheaderColor, SetDHeaderColor] = useState("#E7F6F1");
  const [cHeader, SetCHeader] = useState("Communication");
  const [isTimeSlipLogged, SetIsTimeSlipLogged] = useState(false);
  const [tHeader, SetTHeader] = useState("Timeslip");
  const [isClarraDocsLogged, SetIsClarraDocsLogged] = useState(false);
  const [isAllLogged, SetAllLooged] = useState(false);
  const [dHeader, SetDHeader] = useState("ClarraDocs");
  const [IsComposeMode, SetIsComposeMode] = useState(true);
  const [emailConnected, SetEmailConnected] = useState("");
  const [expanded, setExpanded] = React.useState<string[]>(['panel1']);

  const hasFetchedTimeSlipSettings = React.useRef(false);
  
  const [Logmode, SetLogMode] = useState({
    cm: false,
    tm: false,
    dm: false,
  });
  const ServiceType = useSelector(
    (state: RootState) => state.serviceType.serviceType
  );

  const handleAccordionChange = (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
   
      setExpanded((prevState) =>
      isExpanded ? [...prevState, panel] : prevState.filter((p) => p !== panel)
    );
    console.log("Panel :", panel, isExpanded, formData.CommunicationId);

    if(panel == "panel1") {
      // load communication data if Communicatin id is valid
      console.log("Panel After Check:", panel, isExpanded, formData.CommunicationId);
         setFormData((prev: any) => ({
                    ...prev,
                     PanelOpenState :"panel1"
                }));
    }
    else if (panel == "panel2") {
      // load timeslip data if timeslipId is Valid
       setFormData((prev: any) => ({
                    ...prev,
                     PanelOpenState :"panel2"
                }));
    }
    else if (panel == "panel3") {
      // load ClarraDocs data if ClarradocsId is Valid
        setFormData((prev: any) => ({
                    ...prev,
                     PanelOpenState :"panel3"
                }));
     
     }
  
  };

  const SetCommunicationMode = () => {
    setCommunicationSave(false);
    setShowSuccess(false);
  };
  const DeleteKey = async (email) => {
    try {
      var keyInput = {
        Key: email,
        Value: ''
      }
      const response = await axios.post(API_BASE_URL + DeleteKey, keyInput, {
        headers: {
          Authorization: `Bearer ` + AccessToken,
          'Content-Type': 'application/json',
          'mode': 'outlook'
        },
      });
      return response;
    } catch (error) {
      return keyInput;
    }
  }
  const onCancel = async () => {
    let profileEmail = getStorageItem(LOCALSTORAGE_KEYS.LoggedProfile)
    removeUserByProfileEmail(profileEmail)
    localStorage.removeItem(LOCALSTORAGE_KEYS.AccessToken);
    localStorage.removeItem(LOCALSTORAGE_KEYS.AuthToken);
    await clearTokenManagerSession(); // clears in-memory token + revokes the server-side session, if any
    handleSingOUt(false)

    const loggedUserData = getStorageItem(LOCALSTORAGE_KEYS.LoggedUsers);
    const data = loggedUserData ? JSON.parse(loggedUserData) : null;
    // data is null whenever there's no LoggedUsers list at all (the normal
    // case today - nothing populates that key anymore), which should be
    // treated the same as "no users left" below, not throw and skip the
    // logout() call entirely.
    if (!data || data.length === 0) {
      localStorage.removeItem("PreviousEmail");
      localStorage.removeItem(LOCALSTORAGE_KEYS.AuthToken)
      localStorage.removeItem(LOCALSTORAGE_KEYS.LoggedProfile)
    }

    logout({
      logoutParams: { returnTo: window.location.origin },
    });
  };

  async function getClaim(AccessToken, email: string) {
    try {

      const response = await axios.get(API_BASE_URL + GetPermission, {
        headers: {
          Authorization: `Bearer ` + AccessToken,
          'Content-Type': 'application/json',
          'mode': 'outlook',
          'email':email,
          'servicetype':1
          
        },
      });
      //This can return in the format  [14, 16, 105];
      return response.data;
    } catch (error) {
      return [15, 16, 252, 253];
    }


  }

  const getClaims = async (token) => {
    const userEmail = await new Promise<string>((resolve) => {
    Office.onReady((info) => {
      if (info.host === Office.HostType.Outlook) {
        const userProfile = Office.context.mailbox.userProfile;
        resolve(userProfile.emailAddress);
      } else {
        resolve(""); // fallback if not Outlook
      }
    });
  });
    console.log("Always Claim");
    var claims = null;
    if (claims) {
      var x = claims["https://clarra/permissions"];
      var intitial = claims["https://clarra/initials"];
      setFormData((prevFormData) => ({
        ...prevFormData,
        timekeeper: intitial,
      }));

      if (x == null || x == "") {
        x = await getClaim(token, userEmail);
      }
    }
    else {
      x = await getClaim(token, userEmail);
    }

     let numbers=x;
    
    const checkNumbers = [15, 16];
    const checkCommunication = [105];

  const hasError99 = numbers.includes(-999);
  const hasError88 = numbers.includes(-888);
  const hasError77 = numbers.includes(-777);

  if (hasError99) setPermissionErrorMsg(999);
  else if (hasError88) setPermissionErrorMsg(888);
  else if (hasError77) setPermissionErrorMsg(777);
  else setPermissionErrorMsg(null);

  

  if (hasError99 || hasError88 || hasError77) {
  
    const interval = setInterval(async () => {
      const newNumbers = await getClaim(token, userEmail);
      const stillNegative =
        newNumbers.includes(-999) || newNumbers.includes(-888) || newNumbers.includes(-777);

      if (stillNegative) {
     
        numbers = newNumbers;
        //SetAddAccount(false);
        return; // keep polling
      }

    
      clearInterval(interval);
 setPermissionErrorMsg(null);
      
       setIsLoader(true);
      // SetAddAccount(true);
      setTimeout(() => {
        setIsLoader(false);
        
        getClaims(token); 
      }, 2000);
    }, 5000);
    
    return; 
  }

      


    //const checkCommunication = [263, 264];

    const results = checkNumbers.map((num) => ({
      number: num,
      exists: numbers.includes(num),
    }));
   
    let AddCommunicationPermission = checkCommunication.some((element) => numbers.includes(element));

    if (AddCommunicationPermission) {
      SetAddCommunication(true);
     // SetAddAccount(true);
      setFormData((prev) => ({ ...prev, createCommunication: true }));
      // setCommunicationEnabled(true);
      SetCHeader("Communication");
    }
    else {
      setFormData((prev) => ({ ...prev, createCommunication: false }));
      SetAddCommunication(false);
   
      SetCHeaderColor("#FDEBE6");

    }


    results.forEach((element) => {

      if (element.number == 16) {
        if (element.exists) {
          SetAddTimeslip(true);
          // SetAddAccount(true);
          //nopermission = false;
          SetTHeader("Timeslip");
        }
        else {
          SetAddTimeslip(false);
          // SetAddAccount(false);
          // SetTHeader("Timeslip (Permission Denied)");
          SetTHeaderColor("#FDEBE6");

        }
      }
      if (element.number == 15) {
        if (element.exists) {
          SetAddClarraDocs(true);
        //  SetAddAccount(true);
          SetDHeader("ClarraDocs");
        }
        else {
          SetAddClarraDocs(false);
         //  SetAddAccount(false);
          // SetDHeader("ClarraDocs (Permission Denied)");
          SetDHeaderColor("#FDEBE6");
        }
      }
    });
    
  };



  const getAccessToken = async () => {
    let token = AccessToken;
    let profile = ""; // Office.context.mailbox.userProfile.emailAddress;
    let propName = "AccessToken" + profile;
    if (AccessToken == null) {
      try {

        token = await getManagedAccessToken();
        if (token == null) {
          token = getStorageItem(propName);
        }
        if (token == null) {
          token = await getAccessTokenSilently();
          if (token == null) token = await getAccessTokenSilently();
        }
        if (token != null) {
          SetAccessToken(token);
          SetCommunicationMode();
          // Token now lives in tokenManager's in-memory store (feeding it here
          // means apiClient-based Redux slice calls in this session also have
          // a valid token) rather than localStorage - see src/services/tokenManager.ts.
          setAccessTokenDirect(token);
          getClaims(token); /* change to read permission from server */
        }
      } catch (exception) { }
    }
    return token;
  };

  const ResetFormData = () => {
    setFormData({
      isValid: false,
      profileEmail: null,
      billable: true,
      date: formatDate(new Date()),
      duration: "",
      timekeeper: "",
      matter: "",
      matterid :0,
      tag: [],
      activityCode: "",
      taskCode: "",
      subject: "",
      description: "",
      note: "",
      data: "",
      status: "",
      serviceType: {},
      createClarraDocs: false,
      createCommunication: true,
      createTimeslip: false,
      mailItem: {},
      mailbody: "",
      attachments: files,
      emlattachment: emlfile,
      sendToDocketing: false,
      docketingComplete: false,
      docketingNotes: "",
      Data: "",
      matterdoc: "",
      matteriddoc:0,
      matterdoc_manually_set: false,
      tagdoc: [],
      datedoc: formatDate(new Date()),
      subjectdoc: "",
      descriptiondoc: "",
      attachmentsdoc: files,
      emlFileName: "",
      datets: formatDate(new Date()),
      matterts: "",
      matteridts:0,
      matterts_manually_set: false,
      notedoc: "",
      isClarraDocsReadOnly: false,
      isCEmailLogged: false,
      isTimeSlipLogged: false,
      isClarraDocsLogged: false,
      IsComposedMode: true,
      IsComposedTextShown: false,
      CommunicationId: 0,
      TimeSlipId: 0,
      ClarraDocsId: 0,
      AllLogged: false,
      PanelOpenState : "",
      ZapierDownloadURL:[]
    });
  };

  const getAllData = () => {
    let token = getStorageItem(LOCALSTORAGE_KEYS.AuthToken)
    dispatch(fetchAllServiceType(token));
    //dispatch(GetTimeSlipSetting(token));
    dispatch(fetchAllTags(token));
    dispatch(fetchAllActivityCode(token));
    dispatch(fetchAllTaskCode(token));
    // dispatch(fetchAllContacts(contactParam));
    dispatch(fetchAllUsers(token));
  }

  // Global Function for validation
  useEffect(() => {
    // Expose function globally to be called from index.html
    window.reactFunctionHandler = (data) => {
      const isValid = validateForm();
      formData.isValid = isValid;
      return Promise.resolve(formData);
    };
   
  }, []);

  useEffect(() => {
    setShow(false);
    if (communication) {

      setShowError(false);
      const id = communication.id;
      const tid = communication.timeSlipId;
      const did = communication.mailLogId;

      if (!formData.IsComposedMode) { // Only in read mode
        const tenantId = extractTenantIdFromToken();
        setCustomPropertiesAfterLog({
          communicationId: id,
          timeSlipId: tid,
          clarraDocsId: did,
          tenantId
        });
      }


      //SetAllLooged(false)
      let alllogged = false;
      setExpanded([]);
      if (id > 0) {
        console.log("triggered 1");
        formData.isCEmailLogged = true;
        SetIsEmailLogged(formData.isCEmailLogged);
        formData.CommunicationId = id;
        setFormData((prev) => ({ ...prev, createCommunication: false }));
        SetCHeader("Communication Logged Successfully");
      }
      if (tid > 0) {
        setFormData((prev) => ({
          ...prev,
          isTimeSlipLogged: true,
          TimeSlipId: tid,
          createTimeslip: false,
          isTimeSlipReadOnly: false,
        }));
        SetIsTimeSlipLogged(true);
        SetTHeader("Timeslip Logged Successfully");
      }

      if (did > 0) {
         console.log("triggered 2");
      setFormData((prev) => ({

        ...prev,
        isClarraDocsLogged: true,
        createClarraDocs: false,
        // If you have CommunicationId or other keys you wish to set, do it here:
        CommunicationId: id,
        isClarraDocsReadOnly: true,
      }));
      SetIsClarraDocsLogged(true); // If you use this for any external effect
      SetDHeader("ClarraDocs Logged Successfully");
    }

      if (id > 0 && tid > 0 && did > 0) {
        SetAllLooged(true);
      }

      if (communication.error != null) {
        setShowError(true);
        setShowMessage(communication.error);
      }
      return;
    }
  }, [communication]);

  useEffect(()=>{
    if(formData.PanelOpenState == "")
      setExpanded([]);
  },[formData.PanelOpenState])

  useEffect(() => {
  
    SetIsEmailLogged(formData.isCEmailLogged);

    if (formData.isCEmailLogged) {
      setFormData((prev) => ({ ...prev, createCommunication: false }));
      // Close communication accordion when logged
      setExpanded((prev) => prev.filter(panel => panel !== 'panel1'));
    } else {
      // Open communication accordion when not logged
      setExpanded((prev) => prev.includes('panel1') ? prev : [...prev, 'panel1']);
    }

    if (formData.CommunicationId > 0) {
      SetCHeader("Communication Logged Successfully");
    } else {
      SetCHeader("Communication");
    }

  }, [formData.isCEmailLogged])

  
  useEffect(() => {
    const profileEmail = formData?.profileEmail;
    if (!profileEmail || hasRunRef.current) return;

    hasRunRef.current = true; // Prevent rerun (even under StrictMode)
    SetEmailConnected(profileEmail);

    const previousEmail = getStorageItem(LOCALSTORAGE_KEYS.LoggedProfile);

    if (!previousEmail || previousEmail === "null") {
      console.log('First-time login — setting PreviousEmail');
  
    } else if (previousEmail === profileEmail) {
      console.log("Profile email matches previous email");
      const doseExistProfile = getProfileByEmail(previousEmail)
      console.log('doseExistProfile', doseExistProfile)
      if (!doseExistProfile) {
        // handleLoginChange(false, null)
      }

    } else {
      // Profile changed
      const doseExistProfile = getProfileByEmail(profileEmail)
      if (doseExistProfile) {
        const doseExistToken = getTokenByProfileEmail(profileEmail)
      } 
    }
  }, [formData?.profileEmail]);


  useEffect(() => {
    formData.createTimeslip = false;
    SetIsTimeSlipLogged(formData.isTimeSlipLogged);
    if (formData.isTimeSlipLogged) {
      SetTHeader("Timeslip Logged Successfully");
      formData.createTimeslip = false;
    }
    else
      SetTHeader("Timeslip");
  }, [formData.isTimeSlipLogged])

  useEffect(() => {
    formData.createClarraDocs = false;
    SetIsClarraDocsLogged(formData.isClarraDocsLogged);
    if (formData.isClarraDocsLogged)
      SetDHeader("ClarraDocs Logged Successfully");
    else
      SetDHeader("ClarraDocs");
   

  }, [formData.isClarraDocsLogged])

  useEffect(() => {
    setShowError(ShowError);
    
  }, [ShowError])

  useEffect(() => {
    SetAllLooged(formData.AllLogged);
  }, [formData.AllLogged])

  useEffect(() => {
    SetIsComposeMode(formData.IsComposedMode);
      }, [formData.IsComposedMode])
  useEffect(() => {
    setShow(false);
    if (ErrorOnSaveCommuncation) {
      setShowError(true);
      
      var Message  = "";
      if(ErrorOnSaveCommuncation !=null && ErrorOnSaveCommuncation.error !=null) { 
          Message = ErrorOnSaveCommuncation.error;
      }
      else 
        Message = ErrorOnSaveCommuncation.message;
      setShowMessage(Message);
    }
  }, [ErrorOnSaveCommuncation]);

  useEffect(() => {
    setShow(false);
    if (ErrorOnSavetimeSlip) {

      
      SetShowSuccessMessage(false);
      setShowSuccess(false);
      setShow(true);
      setShowMessage(ErrorOnSavetimeSlip.message);
    }
  }, [ErrorOnSavetimeSlip]);

  useEffect(() => {
    setShow(false);
    if (ErrorOnSaveclarraDocs) {

      
      SetShowSuccessMessage(false);
      setShowSuccess(false);
      setShow(true);
      setShowMessage(ErrorOnSaveclarraDocs.message);
    }
  }, [ErrorOnSaveclarraDocs]);


  useEffect(() => {
    setShow(false);
    if (timeSlip) {
      setMode("TimeSlip");
      SetShowSuccessMessage(true);
      if (checkTMode) {
        setOnlyTimeSlip(false);
        if (checkDMode) {
          setCommunicationSave(true);
          setOnlyDocs(true);
        } else {
          setCommunicationSave(true);
          setShowSuccess(true);
          setShow(true);
          setShowMessage("Successfully logged");
        }
      }
    }
  }, [timeSlip]);

  useEffect(() => {
    setShow(false);
    if (clarraDocs) {
      setMode("ClarraDocs");
      SetShowSuccessMessage(true);
      if (checkDMode) {
        setOnlyTimeSlip(false);
        setCommunicationSave(true);
        setOnlyDocs(false);
        setShowSuccess(true);
        setShow(true);
        setShowMessage("Successfully logged");
      }
    }
  }, [clarraDocs]);

  

 useEffect(() => {
    const fetchData = async () => {
      if (hasFetchedTimeSlipSettings.current) return;
      let token = AccessToken;

      if (!token) {
        // tokenManager covers BOTH login paths: the classic-Outlook (Mac/Win
        // desktop) PKCE + session-handle flow, where the token only ever
        // lives in tokenManager's in-memory store (never localStorage, never
        // an auth0-react session getAccessTokenSilently() can see), and the
        // modern-host auth0-react flow via its registered silent-refresh
        // fallback. Try it first; only fall back to the legacy sources if it
        // has nothing (e.g. tokenManager not yet populated for some reason).
        token = await getManagedAccessToken();
        if (!token) {
          token = await getTokenByLocalStorage();
        }
        if (!token) {
          try {
            token = await getAccessTokenSilently();
          } catch (error) {
            console.error("Silent token fetch failed", error);
          }
        }
        SetAccessToken(token);
        SetCommunicationMode();
        getClaims(token); /* Change Permission call */
      }

      if (token && !tsettings) {
        hasFetchedTimeSlipSettings.current = true;
        dispatch(fetchAllLabels(token));
        dispatch(fetchAllServiceType(token));
        dispatch(GetTimeSlipSetting(token));
      }
    };

    fetchData();
  }, [AccessToken, dispatch]);




    useEffect(() => {
    (async () => {
      //console.log('loginError', LoginError)

      if (LoginError != null) {
        if (LoginError == "200") {
          let token = await getManagedAccessToken();
          if (!token) {
            token = await getTokenByLocalStorage();
          }
          if (!token) {
            try {
                 token = await getAccessTokenSilently();
             } catch (error) {
                  console.error("Silent token fetch failed", error);
            }
          }
          if (!token) {
            return false;
          }
          // SetisValidToken(true);
          const matterParam = {
            AccessTokenParam: token,
            NextPage: 1,
          };

          let Pagenum = 1;
          const contactParam = {
            AccessTokenParam: token,
            NextPage: Pagenum,
          };
          //console.log('in here loginError status 200')
          //dispatch(fetchAllMatters(matterParam));
          dispatch(fetchAllTags(token));
          dispatch(fetchAllMatters(matterParam));
          // setTimeout(() => {
          //     dispatch(fetchAllMatters(matterParam));
          //   }, 100);
          dispatch(fetchAllActivityCode(token));
          dispatch(fetchAllTaskCode(token));
          dispatch(fetchAllContacts(contactParam));
          dispatch(fetchAllUsers(token));
          //dispatch(GetTimeSlipSetting(token));
          SetisValidToken(true);
        } else if (LoginError == "401") {
          SetisValidToken(false);
          onCancel();
        }
      }
    })();
  }, [LoginError]);




    useEffect(() => {
    (async () => {
      if (ErrorStatus != null) {
        if (ErrorStatus.status == "200") {
         console.log('Status is valid ', ErrorStatus)
        } else if (ErrorStatus.status == "401") {
          SetisValidToken(false);
          onCancel();
        }
      }
    })();
  }, [ErrorStatus]);

  useEffect(() => {
   
    (async () => {
      SetTimeSlipSettings(tsettings);
      setLocalStorageItem(LOCALSTORAGE_KEYS.TimeSlipSetting, tsettings);
      if(TimeSlipSetting && TimeSlipSetting.disableTimeTracking){
         SetAddTimeslip(false);
         SetTHeaderColor("#FDEBE6");
       }
      
    })();
  }, [tsettings]);


  
  useEffect(() => {
    SetStorageItem("localStoragekeys", JSON.stringify(LOCALSTORAGE_KEYS));
    console.log('uiDictionary useEffect', uiDictionary);
    if (!labelloading && isLoaded && uiDictionary) {
      console.log("Storing uiDictionary in localStorage",uiDictionary);
      SetStorageItem(
        "uiDictionary",
        JSON.stringify(uiDictionary)
      );
      SetStorageItem("BACKEND_ERROR_MAP", JSON.stringify(BACKEND_ERROR_MAP));
    }
  }, [uiDictionary, labelloading, isLoaded]);

  const statusOptions = [
    { key: "Sent", text: "Sent" },
    { key: "Receive", text: "Receive" },
  ];
  const handleChange = (field: string) => (event: any, newValue?: any) => {
    const value = Array.isArray(newValue)
      ? newValue
      : event?.target?.type === "checkbox"
        ? event.target.checked
        : newValue;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
  };

  const validateEmailForm = (mode: any) => {
    let isValid = true;
    let tempErrors: any = {};
    if (!formData.matter) {
      tempErrors.matter = `${uiDictionary.Matter} is required`;
      isValid = false;
    }
    if (!selectedFrom) {
      tempErrors.From = "Sender is required";
      isValid = false;
    }
    if (selectedTo.length === 0) {
      tempErrors.To = "At least one recipient is required";
      isValid = false;
    }
   
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const validateForm = () => {
    let tempErrors = {
      From: "",
      To: "",
      combinedMessage: "",
      combinedMessagedoc: "",
      combinedMessagets: "",
      matter: "",
      tag: "",
      billable: true,
      date: "",
      duration: "",
      timekeeper: "",
      activityCode: "",
      taskCode: "",
      description: "",
      note: "",
      status: "",
      serviceType: "",
      contact: "",
      matterdoc: "",
      tagdoc: "",
      datedoc: "",
      subjectdoc: "",
      descriptiondoc: "",
      attachmentsdoc: "",
      emlattachment: "",
      emlFileName: "",
      datets: "",
      matterts: "",
      notedoc: "",
      sendToDocketing: false,
      docketingComplete: false,
      docketingNotes: "",
      isCEmailLogged: false,
      IsComposedMode: false,
      IsComposedTextShown: false
    };
    let isValid = true;
    if (formData.createCommunication) {
      if (!formData.matter) {
        tempErrors.matter = `${uiDictionary.Matter} is required`;
        isValid = false;
      }
      if (!selectedFrom || !selectedFrom) {
        tempErrors.From = "Please select a sender";
        isValid = false;
      }
      if (!IsComposeMode && selectedTo.length === 0) {
        tempErrors.To = "At least one recipient is required";
        isValid = false;
      }
    
      if (!isValid) {
        tempErrors.combinedMessage = "Please complete all required fields.";

      }
    }
    if (formData.createTimeslip) {
      isValid = true;
      if (!formData.matterts) {
        tempErrors.matterts = `${uiDictionary.Matter} is required`;
        isValid = false;
      }
      if (!formData.datets) {
        tempErrors.date = "Date is required";
        isValid = false;
      }
      if (TimeSlipSetting != null && TimeSlipSetting.zeroDurationType != null && TimeSlipSetting.zeroDurationType == 3) {
        try {
          if (formData.duration.trim() != "") {
            if (formData.duration.trim().split(".").length == 2) {
              const _d = Number(formData.duration.trim());
              if (_d <= 0) {
                tempErrors.duration = `${uiDictionary.Duration} must be greater than 0`;
                //formData.duration="0.0";
                isValid = false;
              }
            }
            else {
              const _d = Number(formData.duration.trim());
              if (_d <= 0) {
                tempErrors.duration = `${uiDictionary.Duration} must be greater than 0`;
                isValid = false;
              }
            }
          }
          else {
            if (!formData.duration || formData.duration.trim() == "" || formData.duration == "") {
              tempErrors.duration = `${uiDictionary.Duration} is required`;
              isValid = false;
            }
          }
        }
        catch (error) {
          formData.duration = "";
          tempErrors.duration = `${uiDictionary.Duration} is required in hours.minutes format`;
          isValid = false;
        }
      }
      if (!formData.activityCode) {
        tempErrors.activityCode = `${uiDictionary.ActivityCode} is required`;
        isValid = false;
      }
      if (!formData.taskCode) {
        tempErrors.taskCode = `${uiDictionary.TaskCode} is required`;
        isValid = false;
      }
      if (!formData.timekeeper) {
        tempErrors.timekeeper = `${uiDictionary.Timekeeper} is required`;
        isValid = false;
      }
      if (formData.description.length == 0) {
        tempErrors.description = `${uiDictionary.Description} is required`;
        isValid = false;
      }
      if (!isValid) {
        tempErrors.combinedMessagets = "Please complete all required fields.";
      }
    }
    if (formData.createClarraDocs) {
      isValid = true;
      if (!formData.datedoc) {
        tempErrors.datedoc = "Date is required";
        isValid = false;
      }
      if (!formData.matterdoc) {
        tempErrors.matterdoc = `${uiDictionary.Matter} is required`;
        isValid = false;
      }

      if (formData.tagdoc && formData.tagdoc.length === 0) {
        tempErrors.tagdoc = `At least one ${uiDictionary.Tags} is required`;
        isValid = false;
      }

      if (!formData.status) {
        tempErrors.status = `${uiDictionary.Status} is required`;
        isValid = false;
      }
      if (!formData.serviceType) {
        tempErrors.serviceType = `${uiDictionary.MailTypes} is required`;
        isValid = false;
      }
      if (formData.descriptiondoc && formData.descriptiondoc.length == 0) {
        tempErrors.descriptiondoc = `${uiDictionary.Description} is required`;
        isValid = false;
      }
      if (!isValid) {
        tempErrors.combinedMessagedoc = "Please complete all required fields.";

      }
    }


    setErrors(tempErrors);
    formData.isValid = isValid;
    return isValid;
  };
  const handleSubmitNew = (EmailData, Mode: any) => {
    
    setCheckCMode(Mode.cm);
    setCheckTMode(Mode.tm);
    setCheckDMode(Mode.dm);
    SetCurrentMode(1);
 
    const subject = EmailData.mailItem.subject;
    const externalID = EmailData.mailItem.referenceid;
    const conversationid = EmailData.mailItem.conversationid;
  
    const date = EmailData.mailItem.date;

    const from =
      EmailData.mailItem.senderDisplayName +
      " (" +
      EmailData.mailItem.sender +
      ")";

    const To = EmailData.mailItem.recipents;
    const body = EmailData.mailbody;
    const matter = EmailData?.matter?.label; 
    const matterId = EmailData?.matter?.value;
    const tags = EmailData?.tag?.map((v: any) => v.label).join(",");
    const time = EmailData.mailItem.time;
    const Token = AccessToken == null ? EmailData.Token : AccessToken;
    let Recipients = [];

    if (To != null) {
      To.forEach((element) => {
        Recipients.push({
          contactID: Number(element.id.split("|")[0]),
          userID: element.id.split("|")[1],
          fullNameWithEmail:
            element.emailAddress + " (" + element.emailAddress + ")",
          isContact: (element.id.split("|")[1]) == "" ? true : false,
          type: 1,
        });
      });
    }

    let sender = {
      contactID: 0,
      userID: "",
      fullNameWithEmail: from,
      isContact: true,
      type: 1,
    };
    let PayloadData = {
      filter: Token,
      externalID: externalID,
      conversationID: conversationid,
      id: 0,
      communicationType: "Email",
      Subject: subject,
      date: date,
      time: time,
      description: body,
      Matter: {
        MatterId: matterId,
        MatterWithNumber: matter,
      },
      sender: sender,
      recipients: Recipients,
      CommunicationTags: [
        {
          TagID: 0,
          TagName: tags,
        },
      ],

      // UploadFileAttachments: EmailData.mailItem.attachments,
      CreateClarraDocs: null,
      ClarraDocsStatus: null,
      ServiceType: null,
      TimeZone: EmailData.mailItem.timezone, 
    
      
    };
   
    SetFiles(EmailData.mailItem.attachments);
    if (!Mode.cm) {
      if (Mode.tm) {
        handleSubmitNewTimeSlip(EmailData);
        
      } else {
        if (Mode.dm) {
          handleSubmitNewClarraDocs(EmailData);
         
        } else {
           console.log("You have to Select one of the Checkbox");
        }
      }
    } else {
       //console.log("Submitting TimeSlip only with Payload:1", PayloadData);
      dispatch(SaveCommuncation(PayloadData));
     
    }
  };

  const handleSubmitCommunication = (EmailData: any) => {

    console.log("Time Zone - " + EmailData.mailItem.timezone);
    setCheckCMode(EmailData.createCommunication);
    setCheckCMode(EmailData.createClarraDocs);
    setCheckCMode(EmailData.createTimeslip);

    SetCurrentMode(1);
 
    const subject = EmailData.mailItem.subject;
    const externalID = EmailData.mailItem.referenceid;
    const conversationid = EmailData.mailItem.conversationid;
    const internetMessageId = EmailData.mailItem.internetMessageId;

 
    const date = EmailData.mailItem.date;

  

    const from =
      EmailData.mailItem.senderDisplayName +
      " (" +
      EmailData.mailItem.sender +
      ")";

    const To = selectedTo; // EmailData.mailItem.recipents;
    const Cc = selectedCc; // EmailData.mailItem.cc;
    const body = EmailData.mailItem.body;
    const matter = EmailData?.matter;
    //const matterNumber = (EmailData?.matter?.value) ? EmailData?.matter?.value : null;
    const matterId = (EmailData?.matterid) ? EmailData?.matterid : 0;
    const tags = EmailData?.tag?.map((v: any) => v.label).join(",");
    const time = EmailData.mailItem.time;
    const Token = AccessToken == null ? EmailData.Token : AccessToken;
    let Recipients = [];

    if (To != null) {
      To.forEach((element) => {
        Recipients.push({
          contactID: Number(element.value.split("|")[0]),
          userID: element.value.split("|")[1],
          fullNameWithEmail:
            // element.label + " (" + element.label + ")",
            element.label.replace("<", "(").replace(">", ")"),
          isContact: (element.value.split("|")[1]) == "" ? true : false,
          type: 1,
        });
      });
    }

    let CcRecipients = [];
    if (Cc != null) {
      Cc.forEach(element => {
        CcRecipients.push({
          contactID: Number(element.value.split("|")[0]),
          userID: element.value.split("|")[1],
          fullNameWithEmail: element.label.replace("<", "(").replace(">", ")"),
          isContact: (element.value.split("|")[1]) == "" ? true : false,
          type: 2,
        });
      });
    }


    let sender = {
      contactID: 0,
      userID: "",
      fullNameWithEmail: from,
      isContact: true,
      type: 1,
    };
    let PayloadData = {
      filter: Token,
      externalID: externalID,
      conversationID: conversationid,
      internetMessageID : internetMessageId,
      id: 0,
      communicationType: "Email",
      Subject: subject,
      date: date,
      time: time,
      description: body,
      Matter: {
        MatterId: matterId,
        MatterWithNumber: matter,
      },
      sender: sender,
      recipients: Recipients,
      CC: CcRecipients,
      CommunicationTags: [
        {
          TagID: 0,
          TagName: tags,
        },
      ],
      CreateCommunication: EmailData.createCommunication,
      UploadFileAttachments: EmailData.attachments,
      CreateClarraDocs: (EmailData.createClarraDocs == true) ? true : false,
      ClarraDocsStatus: null,
      onlydocs: (EmailData.createCommunication == true) ? false : true,
      ClarraDocs: (EmailData.createClarraDocs == true) ? handleSubmitNewClarraDocs(EmailData) : null,
      ServiceType: null,
      TimeSlip: (EmailData.createTimeslip == true) ? handleSubmitNewTimeSlip(EmailData) : null,
      TimeZone: EmailData.mailItem.timezone, // "(UTC-08:00) Pacific Time (US & Canada)",
      CreateTimeSlip: EmailData.createTimeslip,
      ZapierDownloadURL:EmailData.ZapierDownloadURL
    };
    // console.log(PayloadData);
    //return;
    // SetFiles(EmailData.attachments);
    if (!EmailData.createCommunication && !EmailData.createClarraDocs) {
      if (EmailData.createTimeslip) {
          PayloadData.Matter = {
          MatterId: 0,
          MatterWithNumber: EmailData.matterts
        };
        console.log("Submitting TimeSlip only with Payload:2", PayloadData);

        dispatch(SaveCommuncation(PayloadData));
        
      }
    }
    else {
      if (!EmailData.createCommunication && EmailData.createClarraDocs) {
        PayloadData.Matter = {
          MatterId: EmailData.matteriddoc,
          MatterWithNumber: EmailData.matterdoc,
        };
      }
       console.log("Submitting TimeSlip only with Payload:3", PayloadData);
      dispatch(SaveCommuncation(PayloadData));
    }
  };
 
  const TimeSlipPayload = (EmailData: any) => {

    let PayloadData = {
      externalID: null,
      data: AccessToken == null ? EmailData.Token : AccessToken,
      id: 0,
      date: EmailData.datets,
      duration: (EmailData.duration == "") ? 0.0 : EmailData.duration,
      timekeeper: EmailData.timekeeper,
      matter: EmailData.matterts,
      matterId: EmailData.matteridts,
      type: EmailData.activityCode,
      project: EmailData.taskCode,
      description: EmailData.description,
      notes: EmailData.note,
      billable: EmailData.billable
    };

    return PayloadData;

  }

  const ClarraDocsPayload = (EmailData: any) => {

    const matter = EmailData.matterdoc;
    const matterid = EmailData.matteriddoc;
    const status = EmailData.status;
    const serviceType = EmailData.serviceType?.label;
    const tags = EmailData?.tagdoc?.map((v: any) => v.label);
    const SendToDocketing = EmailData.sendToDocketing;
    const docketingComplete = EmailData.docketingComplete;
    const DocketingNote = EmailData.docketingNotes;
    let PayloadData = {
      externalID: null,
      id: 0,
      //Files: ClarraDocsData.attachments,
      Note: EmailData.notedoc,
      MailType: serviceType,
      MatterNumber: matter,
      MatterId:matterid,
      Date: EmailData.datedoc,
      Status: status,
      Description: EmailData.descriptiondoc,
      Tags: tags,
      SendToDocketing: SendToDocketing,
      CompleteDocketing: docketingComplete,
      DocketingNote: DocketingNote,
      UploadFileAttachments: EmailData.attachmentsdoc,
    };
    return PayloadData;

  }
  const handleSubmitNewTimeSlip = (TimeSlipData) => {

    SetCurrentMode(2);
    let comm_id = 0;
    // if(communication !=null){
    //   comm_id = communication.id;
    // }

    if (formData.CommunicationId > 0) {
      comm_id = formData.CommunicationId;
    }
    let PayloadData = {
      externalID: null,
      id: 0,
      date: TimeSlipData.datets,
      duration: (TimeSlipData.duration == "") ? 0.0 : TimeSlipData.duration,
      timekeeper: TimeSlipData.timekeeper,
      matter: TimeSlipData.matterts,
      matterId : TimeSlipData?.matteridts,
      type: TimeSlipData.activityCode,
      project: TimeSlipData.taskCode,
      description: TimeSlipData.description,
      notes: TimeSlipData.note,
      billable: TimeSlipData.billable,
      CommunicationID: comm_id
    };

    return PayloadData;

    if (TimeSlipData.createTimeslip == true) {
      dispatch(SaveTimeSlip(PayloadData));
    }
  };

  const EmailLogged = (flag) => {

    SetIsEmailLogged(flag);
  }
  const handleSubmitNewClarraDocs = (ClarraDocsData) => {

   
    const matter = ClarraDocsData?.matterdoc;
    const matterId = ClarraDocsData?.matteriddoc;
    const status = ClarraDocsData?.status?.label;
    const serviceType = ClarraDocsData?.serviceType?.label;
    const tags = ClarraDocsData?.tagdoc?.map((v: any) => v.label);
    const SendToDocketing = ClarraDocsData?.sendToDocketing;
    const docketingComplete = ClarraDocsData?.docketingComplete;
    const DocketingNote = ClarraDocsData?.docketingNotes;
    let PayloadData = {
      externalID: null,
      // data: AccessToken == null ? ClarraDocsData.Token : AccessToken,
      id: 0,
      //Files: ClarraDocsData.attachments,
      Note: ClarraDocsData.notedoc,
      MailType: serviceType,
      MatterNumber: matter,
      MatterId : matterId,
      Date: ClarraDocsData.datedoc,
      Status: status,
      Description: ClarraDocsData.descriptiondoc,
      Tags: tags,
      SendToDocketing: SendToDocketing,
      CompleteDocketing: docketingComplete,
      DocketingNote: DocketingNote,
      UploadFileAttachments: ClarraDocsData.attachmentsdoc,
      // ZapierDownloadURL:ClarraDocsData.attachmentsdoc,
      onlydocs: true
    };
    return PayloadData;

  };

  const handleFromCompose = () => {
    const isValid = validateForm();
  }

  const handleSave = () => {

    const isValid = validateForm();
    var s = getLocalStorageItem(LOCALSTORAGE_KEYS.formData);
    var s1 = formData;
    if (isValid) {
      handleSubmitCommunication(formData);
    }
    else {
      }
  }
  const openOutlookDialog = () => {

     let data1 =  
                  {
                        id : "",
                        subject : "",
                        MessageId : "",
                        Emailsubject : ""
                    };
    let data = "";
    if(getStorageItem("EmailAPIObject") !=null){
      data = getStorageItem("EmailAPIObject");
      const jdata = JSON.parse(data);
      jdata.Emailsubject = formData.description;
      data =  JSON.stringify(jdata);
    }
    else 
      data =  JSON.stringify(data1);
       
      const infoUrl = window.location.origin + `/assets/info.html?data=${encodeURIComponent(
         JSON.stringify(data)
      )}`;
  
      Office.context.ui.displayDialogAsync(infoUrl, { height: 40, width: 30 }, (asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
          console.error("Dialog failed:", asyncResult.error.message);
        } else {
          const dialog = asyncResult.value;
  
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
            dialog.close();
          });
        }
      });
  };

 

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, field: string, panel: string) => {
    const { checked } = e.target;

     setFormData((prevFormData) => {
      const newFormData = {
        ...prevFormData,
        [`create${field}`]: checked,
      };

      const isAnyLoggingEnabled =
        newFormData.createCommunication ||
        newFormData.createTimeslip ||
        newFormData.createClarraDocs;

      // Set the mode based on whether any logging is active
      if (isAnyLoggingEnabled) {
        console.log("Add-in is active. Setting mode to 1.");
        SetStorageItem(LOCALSTORAGE_KEYS.mode, "1");
      } else {
        console.log("Add-in is inactive. Setting mode to 0.");
        SetStorageItem(LOCALSTORAGE_KEYS.mode, "0");
      }

      // Return the new state for React to update the component
      return newFormData;
    });

    setExpanded((prevState) =>
      checked ? (prevState.includes(panel) ? prevState : [...prevState, panel]) : prevState
    );
  };


  return (

    <>
      {(isLoader || tags.length === 0) &&
        <div>
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 1300,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 1)",
            }}
          >
            {/* Wrapper for vertical alignment */}
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Loader />
              {/* <div style={{ marginTop: "16px", fontSize: "16px", color: "#555" }}>
                Loading data. Please hold on a moment...
              </div> */}
            </Box>
          </Box>
        </div>
      }
      <div style={{ alignItems: "right" }}>
        <div>
        

          
       {(loading || timeSlipLoading || clarraDocsLoading || composeProgress>0 || composeLoader) && (
            <Box
              sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1300,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255, 1)",
              }}
            >
              <Box sx={{ textAlign: "center", width: "250px" }}>
                <Loader />
                
                {(uploadProgress > 0 && uploadProgress < 100) || (composeProgress > 0 && composeProgress < 100) ? (
                  <>
                    <div style={{ marginTop: "15px", fontWeight: "bold" }}>Uploading Attachments...</div>
                    <Box sx={{ marginTop: "16px", width: "100%", height: "8px", backgroundColor: "#e0e0e0", borderRadius: "4px", overflow: "hidden" }}>
                      <Box sx={{ height: "100%", width: `${uploadProgress || composeProgress}%`, backgroundColor: "#17b898", transition: "width 0.3s ease" }} />
                    </Box>
                    <div style={{ marginTop: "8px", fontSize: "12px" }}>{uploadProgress || composeProgress}% Complete</div>
                  </>
                ) : (
                  <div style={{ marginTop: "15px" }}>Logging....</div>
                )}
              </Box>
            </Box>
          )}



          {ShowError && (
            <CommunicationStatus
              mode={mode}
              show={ShowError}
              message={ShowMessage}
              onClose={(mode) => {
                setShowError(mode);
              }} />
          )}


{isValidToken && permissionErrorMsg ? (
  <Permission message={permissionErrorMsg } email={emailConnected}/>
) : (
  isValidToken &&
  !addCommunication &&
  !addTimeSlip &&
  !addClarraDocs && (
    <Permission />
  )
)}


          {/* {isValidToken && !addCommunication && !addTimeSlip && !addClarraDocs && <Permission />} */}

          {isValidToken && !addCommunication && (

            <EmailLoggingForm
              formData={formData}
              setFormData={setFormData}
              setOnlyTimeSlip={setOnlyTimeSlip}
              createTimeslip={formData.createTimeslip}
              setOnlyDocs={setOnlyDocs}
              createClarraDocs={formData.createClarraDocs}
              setCommunicationSave={setCommunicationSave}
              SetEmailItem={SetEmailItem}
              expanded={expanded}
              errors={errors}
              setSelectedFrom={setSelectedFrom}
              selectedFrom={selectedFrom}
              selectedTo={selectedTo}
              setSelectedTo={setSelectedTo}
              selectedCc={selectedCc}
              setSelectedCc={setSelectedCc}
              setErrors={setErrors}
              Reset={true}
              IsLogged={isEmailLogged}
              hideView={true}
              onSubmit={(data, Mode) => {
                setFormData(data);
                handleSubmitNew(data, Mode);
              }}

              getAllData={getAllData}
            />
          )}

          {(!showSuccess && addCommunication && !permissionErrorMsg) && (<Accordion
            expanded={expanded.includes('panel1')} onChange={handleAccordionChange('panel1')}
          >

            <AccordionSummary style={{ ...((isEmailLogged || !addCommunication) && { backgroundColor: cheaderColor }) }}
              expandIcon={expanded.includes('panel1') ? <ExpandLessIcon /> : <ChevronRightIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              {(!isEmailLogged) && (
                <input
                  type="checkbox"
                  className={`form-checkbox h-5 w-5 rounded ${formData.createCommunication ? '' : 'transparent'
                    }`}
                  style={{
                    backgroundColor: formData.createCommunication ? '#28b898' : 'transparent',
                    borderColor: '#28b898',
                  }}
                  checked={formData.createCommunication}
                 
                  onChange={(e) => handleCheckboxChange(e, 'Communication', 'panel1')}
                  onClick={(e) => e.stopPropagation()}
                  disabled={!addCommunication}
                />
              )}
              <div style={{ display: 'block' }}>

              

                {isEmailLogged && (
                  <p style={{ display: 'flex', fontWeight: 'bold' }}>
                   
                    {cHeader}
                  </p>
                )}
                {!isEmailLogged && (
                  <div style={{ display: 'flex', fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;   {cHeader === "Communication"
      ? uiDictionary?.Communication
      : `${uiDictionary?.Communication} Logged Successfully`
    }
                    {formData.createCommunication && <p className="text-red-500 ml-1">*</p>}
                  </div>
                )}

                {!expanded.includes('panel1') && formData.createCommunication && errors.combinedMessage && (
                  <p className="text-sm text-gray-600" style={{ paddingLeft: "10px" }}> {errors.combinedMessage}</p>
                )}
                {!addCommunication && (
                  <p className="text-sm text-red-600" style={{ paddingLeft: "10px" }}>Permission Denied</p>
                )}

              </div>
            </AccordionSummary>
            <AccordionDetails>
              {isValidToken && !isCommunicationSave && (

                <EmailLoggingForm
                  formData={formData}
                  setFormData={setFormData}
                  setOnlyTimeSlip={setOnlyTimeSlip}
                  createTimeslip={formData.createTimeslip}
                  setOnlyDocs={setOnlyDocs}
                  createClarraDocs={formData.createClarraDocs}
                  setCommunicationSave={setCommunicationSave}
                  SetEmailItem={SetEmailItem}
                  expanded={expanded}
                  errors={errors}
                  setSelectedFrom={setSelectedFrom}
                  selectedFrom={selectedFrom}
                  selectedTo={selectedTo}
                  setSelectedTo={setSelectedTo}
                  selectedCc={selectedCc}
                  setSelectedCc={setSelectedCc}
                  setErrors={setErrors}
                  Reset={true}
                  IsLogged={isEmailLogged}
                  hideView={false}
                  onSubmit={(data, Mode) => {
                    setFormData(data);
                    handleSubmitNew(data, Mode);
                  }}
                  getAllData={getAllData}
                />

              )}
            </AccordionDetails>
          </Accordion>
          )}
          {(!showSuccess && addTimeSlip &&!permissionErrorMsg) && (<Accordion
            expanded={expanded.includes('panel2')} onChange={handleAccordionChange('panel2')}
          >
            <AccordionSummary style={{ ...((isTimeSlipLogged || !addTimeSlip) && { backgroundColor: theaderColor }) }}
              expandIcon={expanded.includes('panel2') ? <ExpandLessIcon /> : <ChevronRightIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              {(!isTimeSlipLogged) && (
                <input
                  type="checkbox"
                  className={`form-checkbox h-5 w-5 rounded ${formData.createTimeslip ? '' : 'transparent'
                    }`}
                  style={{
                    backgroundColor: formData.createTimeslip ? '#28b898' : 'transparent',
                    borderColor: '#28b898',
                  }}
                  checked={formData.createTimeslip}
                 
                  onChange={(e) => handleCheckboxChange(e, 'Timeslip', 'panel2')}
                  onClick={(e) => e.stopPropagation()}
                  disabled={!addTimeSlip}
                />
              )}
              <div style={{ display: 'block' }}>
                {isTimeSlipLogged && (
                  <div style={{ display: 'flex', fontWeight: 'bold' }}>{tHeader === "Timeslip"
                          ? uiDictionary?.Timekeeping
                          : `${uiDictionary?.Timekeepingalert} Logged Successfully`
                        }
                    {formData.createTimeslip && <p className="text-red-500 ml-1">*</p>}
                  </div>
                )}
                {!isTimeSlipLogged && (
                  <div style={{ display: 'flex', fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;   {tHeader === "Timeslip"
                          ? uiDictionary?.Timekeeping
                          : `${uiDictionary?.Timekeepingalert} Logged Successfully`
                        }
                    {formData.createTimeslip && <p className="text-red-500 ml-1">*</p>}
                  </div>
                )}
                {!expanded.includes('panel2') && formData.createTimeslip && errors.combinedMessagets && (
                  <p className="text-sm text-gray-600" style={{ paddingLeft: "11px" }}> {errors.combinedMessagets}</p>
                )}
                {(!addTimeSlip) && (
                  <p className="text-sm text-red-600" style={{ paddingLeft: "10px" }}>Permission Denied</p>
                )}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              {isValidToken &&
                (
                  <LogTimeslipForm
                    handleSubmitNewTimeSlip={handleSubmitNewTimeSlip}
                    setCommunicationSave={setCommunicationSave}
                    setOnlyTimeSlip={setOnlyTimeSlip}
                    data={formData}
                    TimeSlipSetting={TimeSlipSetting}
                    SetTimeSlipSettings={SetTimeSlipSettings}
                    setErrors={setErrors}
                    errors={errors}
                    expanded={expanded}
                    formData={formData}
                    setFormData={setFormData}
                  />
                )}
            </AccordionDetails>
          </Accordion>
          )}
          {(!showSuccess && addClarraDocs &&!permissionErrorMsg) && (<Accordion
            expanded={expanded.includes('panel3')} onChange={handleAccordionChange('panel3')}
          >
            <AccordionSummary style={{ ...((isClarraDocsLogged || !addClarraDocs) && { backgroundColor: dheaderColor }) }}
              expandIcon={expanded.includes('panel3') ? <ExpandLessIcon /> : <ChevronRightIcon />}
              aria-controls="panel3-content"
              id="panel3-header"
            >
              {(!isClarraDocsLogged) && (
                <input
                  type="checkbox"
                  className={`form-checkbox h-5 w-5 rounded ${formData.createClarraDocs ? '' : 'transparent'
                    }`}
                  style={{
                    backgroundColor: formData.createClarraDocs ? '#28b898' : 'transparent',
                    borderColor: '#28b898',
                  }}
                  checked={formData.createClarraDocs}
                  onChange={(e) => handleCheckboxChange(e, 'ClarraDocs', 'panel3')}
                  onClick={(e) => e.stopPropagation()}
                  disabled={!addClarraDocs}
                />
              )}
              <div style={{ display: 'block' }}>
                {isClarraDocsLogged && (
                  <div style={{ display: 'flex', fontWeight: 'bold' }}>{dHeader}
                    {formData.createClarraDocs && <p className="text-red-500 ml-1">*</p>}
                  </div>
                )}
                {!isClarraDocsLogged && (
                  <div style={{ display: 'flex', fontWeight: 'bold' }}>&nbsp;&nbsp;&nbsp;   {dHeader === "ClarraDocs"
                      ? uiDictionary?.ClarraDocs
                      : `${uiDictionary?.ClarraDocs} Logged Successfully`
                    }
                    {formData.createClarraDocs && <p className="text-red-500 ml-1">*</p>}
                  </div>
                )}

                {!expanded.includes('panel3') && formData.createClarraDocs && errors.combinedMessagedoc && (
                  <p className="text-sm text-gray-600" style={{ paddingLeft: "12px" }}> {errors.combinedMessagedoc}</p>
                )}
                {!addClarraDocs && (
                  <p className="text-sm text-red-600" style={{ paddingLeft: "10px" }}> Permission Denied</p>
                )}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              {isValidToken &&
                (
                  <LogClarraDocsForm
                    handleSubmitNewClarraDocs={handleSubmitNewClarraDocs}
                    ResetFormData={ResetFormData}
                    setCommunicationSave={setCommunicationSave}
                    setOnlyDocs={setOnlyDocs}
                    files={files}
                    data={formData}
                    setErrors={setErrors}
                    errors={errors}
                    expanded={expanded}
                    formData={formData}
                    setFormData={setFormData}
                    //isComposeMode={IsComposeMode}
                  />
                )}
            </AccordionDetails>
          </Accordion>
          )}

          {/* isEmailLogged */}
          {false && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "90vh", // Ensure it takes the full viewport height
                textAlign: "center",
                margin: "0 auto",
              }}
            >
              <div>
                <img
                  src="../../assets/success.jpg"
                  alt="Success"
                  style={{
                    width: "100px",
                    height: "100px",
                    marginBottom: "2px", // Add spacing between the image and text
                  }}
                />
              </div>
              <h2
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "green",
                }}
              >
                The email has been successfully logged.
              </h2>
            </div>
          )}

          {ShowMessageWindow && <Status
            showSuccess={showSuccess}
            setCommunicationSave={SetCommunicationMode}
            isOnlyTimeSlip={isOnlyTimeSlip}
            isOnlyDocs={isOnlyDocs}
            isCommunicationSave={isCommunicationSave}
            msg={ShowMessage}
            mode={CurrentMode}
            onOk={(flag, retComm, mode) => {

              setShowSuccess(flag);
              
              setShow(flag);
            }}

        
          />
          }
        </div>
       
        <div
          className="flex justify-center items-center font-bold"
          style={{ marginTop: '2rem', marginRight: '1rem', textAlign: 'center' }}
        >
          {(!showSuccess && formData.IsComposedTextShown) && (
            <div className="text-gray-500">Click Send to send and log to Clarra</div>
          )}
        </div>
<div className="flex justify-center mt-2 mr-4">
  {!showSuccess && (
    <div className="flex flex-col items-center gap-2 sm:gap-3">
      
      {/* Top row – Info Icon */}
      {!formData.IsComposedMode &&
        !permissionErrorMsg &&
        formData.CommunicationId > 0 &&
        formData.PanelOpenState === "panel1" && (
          <Tooltip title="More information about the selected email">
            <IconButton
              size="small"
              onClick={openOutlookDialog}
              className="mb-1"
            >
              <InfoOutlinedIcon fontSize="small" color="action" />
            </IconButton>
          </Tooltip>
        )}

      {/* Second row – Buttons */}
      <div className="flex flex-row justify-center gap-3 sm:gap-4">
        {/* Sign Out */}
        <button
          type="button"
          className="px-6 py-2 border rounded-lg hover:bg-gray-50"
          onClick={onCancel}
        >
          Sign out
        </button>

        {/* Log to Clarra */}
        {!formData.IsComposedMode &&
          !permissionErrorMsg &&
          !isAllLogged &&
          (addCommunication || addTimeSlip || addClarraDocs) && (
            <button
              type="submit"
              onClick={handleSave}
              className="px-6 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
            >
              Log to Clarra
            </button>
          )}
      </div>
    </div>
  )}
</div>




      </div>
    </>
  );
};

export default BaseComponent;
